<template>
	<div
		v-show="anyShown"
		class="generic-menu"
		:class="{ 'generic-menu--open': open }"
		v-click-outside="() => open = false"
		@click.stop="open = !open"
	>
		<img
			class="generic-menu__icon"
			src="@/assets//sidebar-icons/menu-dots.svg"
		/>
		<div class="generic-menu-items" v-if="open">
			<div
				class="generic-menu-items-item"
				v-for="(item, i) in items"
				v-show="item.show === undefined || item.show"
				:key="i"
				:style="item.style"
				@click.stop="clickItem(item)"
				:class="{ 'disabled': item.disabled }"
			>
				<div class="generic-menu-items-item__main">
					<div class="generic-menu-items-item-icon">
						<img v-if="item.icon" :src="getIconData(item.icon).path" :style="getIconData(item.icon).style" class="generic-menu-items-item-icon__image"/>
					</div>
					<div class="generic-menu-items-item__text">{{ item.text }}</div>
				</div>
				<Toggle class="generic-menu-items-item__toggle" v-if="item.toggle" :offText="item.toggle.offText" :onText="item.toggle.onText" width="70px" v-model="item.toggle.value" :disabled="item.toggle.disabled || false"/>
				<div class="tooltip-container" v-if="item.disabledText && item.toggle.disabled">
					<FadeTransition :inDuration="100" :outDuration="100">
						<Tooltip :data="{text: item.disabledText}" />
					</FadeTransition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import genericMenuIcons from "./genericMenuIcons.js"
import { Toggle } from "@/framework"
import Tooltip from '@/components/global/Tooltip.vue';
import FadeTransition from '@/components/transitions/FadeTransition.vue';

export default {
	components: {
		Toggle, Tooltip, FadeTransition
	},
	props: {
		items: { type: Array, default: () => [] }
	},
	data: () => ({
		open: false,
		timeout: 0
	}),
	methods: {
		clickItem(item) {
			if(item.disabled) return
			item.click()

			// Close the menu after clicking if it's not a toggle
			if (!item.toggle) {
				this.open = false
			}
		},
		getIconData(keyOrPath) {
			let data = null
			if (keyOrPath in genericMenuIcons) {
				data = genericMenuIcons[keyOrPath]
			} else {
				data = {
					path: keyOrPath
				}
			}

			if (data.size) {
				data.style = {
					'--icon-height': data.size
				}
			}

			return data
		}
	},
	computed: {
		anyShown: vm => Boolean(vm.items.filter(item => item.show === undefined || item.show).length)
	}
}
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
	0% {opacity: 0}
	100% {opacity: 1}
}

.generic-menu {
	$menu-height: 40px;
	$r: &;

	width: 20px;
	height: $menu-height;
	box-sizing: border-box;
	border-radius: 1000px;
	position: relative;
	background-color: rgba(0,0,0,0.25);
	transition: background-color 0.2s;
	flex-shrink: 0;

	// for positioning the icon
	display: flex;
	justify-content: center;
	align-items: center;

	&__icon {
		opacity: 0.75;
		transition: opacity 0.2s;
	}

	&:hover, &--open {
		background-color: rgba(0,0,0,0.65);
		#{$r}__icon {
			opacity: 1;
		}
	}

	&-items {
		position: absolute;
		z-index: 100;
		right: 0;
		top: $menu-height + 10px;
		border-radius: 17px;
		background-color: #383838;
		box-shadow: 0px 0px 4px #00000066;
		color: white;
		font-size: 14px;
		overflow: hidden;
		animation: fadeIn 0.25s;
		min-width: max-content;

		&-item {
			--icon-height: 18px;

			position: relative;
			padding: 12px 20px;
			min-width: max-content;
			width: calc(100% - 40px);
			line-height: 12px;
			display: grid;
			grid-auto-flow: column;
			align-items: center;
			transition: background-color 0.125s;
			font-weight: bold;
			cursor: pointer;

			&.disabled {
				cursor: default;
				& > * {
					opacity: 0.5;
					pointer-events: none;
				}
			}

			&:hover:not(.disabled) {
				background-color: rgba(255,255,255,0.1) !important;
			}

			&__toggle {
				z-index: 10;
			}

			&__main {
				height: 18px;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}

			&-icon {
				width: 18px;
				height: 18px;
				margin-right: 12px;
				position: relative;

				&__image {
					height: var(--icon-height);
					max-height: unset;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
			}

			&__text {
				justify-self: flex-start;
			}

			& .toggle {
				justify-self: flex-end;
				margin-left: 15px;
				opacity: 0.8;
				margin-bottom: 0;
			}

			& .tooltip-container {
				display: none;
			}
			&:hover {
				& .tooltip-container {
					position: absolute;
					display: flex;
					align-items: center;
					padding: 0 0.5rem;
					pointer-events: all;
					opacity: 1 !important;
				}
			}
		}
	}
}
</style>
